import type { FunctionalComponent as FC } from 'vue'

export type ButtonItem = {
  key?: any
  text: string
  props?: any
  onClick: (checkList: any[], reload?: () => void, keyItem?: any) => void
}

type IProps = {
  list: ButtonItem[]
  checkList?: any[]
  data?: any[]
  keyItem?: any
  reload?: () => void
}

export const ButtonList: FC<IProps> = (props) => {
  const disabledCheck = (item: any) => {
    if (item?.props?.disabled !== undefined) {
      if (typeof item.props.disabled !== 'function') {
        return item?.props?.disabled
      }
      return item.props.disabled?.({
        checkList: props.checkList,
        list: props.data,
      })
    }
    return props.checkList?.length === 0
  }

  return (
    <div class="flex-center gap-x-[12px]">
      {props.list.map((item) => (
        <a-button
          onClick={() =>
            item.onClick(props.checkList || [], props.reload, props?.keyItem)
          }
          {...item.props}
          disabled={disabledCheck(item)}
        >
          {item.text}
        </a-button>
      ))}
    </div>
  )
}
